if (!customElements.get('adev-sticky-atc')) {
    customElements.define('adev-sticky-atc', class adevStickyAtc extends HTMLElement {
        constructor() {
            super();
            this.selectorToPass = 'product-form-component';
        }

        initButton() {
            const button = this.querySelector('[data-adev-sticky-atc="button"]');
            if (!button) return;

            button.addEventListener('click', this.onAddToCartClick.bind(this));
        }

        onAddToCartClick() {
            const target = document.querySelector(this.selectorToPass);
            if (!target) return;

            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        destroyButton() {
            const button = this.querySelector('[data-adev-sticky-atc="button"]');
            if (!button) return;
            
            button.removeEventListener('click', this.onAddToCartClick.bind(this));
        }

        onScroll() {
            const target = document.querySelector(this.selectorToPass);

            const isScrolledAtTheBottomOfThePage = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

            if (isScrolledAtTheBottomOfThePage) {
                this.classList.remove('is--active');
            } else {
                const rect = target.getBoundingClientRect();
                if (rect.bottom <= 0) {
                    this.classList.add('is--active');
                } else {
                    this.classList.remove('is--active');
                }
            }
        }

        init() {
            const target = document.querySelector(this.selectorToPass);
            if (!target) return;

            window.addEventListener('scroll', this.onScroll.bind(this));
        }

        destroy() {
            window.removeEventListener('scroll', this.onScroll.bind(this));
        }

        connectedCallback() {
            this.init();
            this.initButton();
        }

        disconnectedCallback() {
            this.destroy();
            this.destroyButton();
        }

    });
}